/* ODKAZ NA DOPORUČENÍ — jedno místo pro získání odkazu, QR a odkazy ke sdílení.
 * ============================================================================
 *
 * PROČ (majitel 14. 10. 2026): „na konci plánu rovnou vygenerovat odkaz na
 * doporučení!!! ať je tam možnost na tu klientku poslat rovnou.. hustý!!"
 * Odkaz se dřív dal vytvořit jen ve složce klienta (ReferralLinkButton
 * v ClientDetailRaynet). Teď ho potřebují tři místa — složka, konec prezentace
 * plánu (QR na plátně) a gentlemanská dohoda v analýze — a každé si ho NESMÍ
 * skládat po svém: jinak by tři obrazovky posílaly tři různé zprávy a tři
 * různé tokeny.
 *
 * CO TU JE (bez Reactu, testovatelné samostatně):
 *   · ziskejOdkazNaDoporuceni — POST /api/referral/generate s contact_id.
 *       Odkaz se pro jednoho klienta získá JEDNOU: hotový se drží v paměti,
 *       souběžná volání (React StrictMode, dvě komponenty naráz) čekají na
 *       TENTÝŽ požadavek. Backend navíc vrací tentýž nevyplněný token
 *       (routes/referral.py), takže ani nové načtení stránky nevyrobí další.
 *   · odkazyKSdileni — WhatsApp / SMS / e-mail s hotovou zprávou. Bez telefonu
 *       se SMS nenabízí, bez platného e-mailu e-mail ne (žádné tlačítko, které
 *       nikam nevede). WhatsApp bez čísla otevře výběr příjemce (lib/crm/
 *       zpravaDoporuceni.js — tak to chtěl majitel už v 8/2026).
 *   · qrMatice / qrCesta — QR kód vykreslený LOKÁLNĚ balíkem `qrcode`
 *       (žádná externí služba, odkaz s tokenem nikam neodchází).
 *   · odkazSJazykem — odkaz s `?lang=` jazyka zprávy / prezentace: stránka
 *       /d/… (pages/ReferralPage.js) se otevře v jazyce, ve kterém klientka
 *       četla snímek a zprávu, ne česky (kontrola 14. 10. 2026).
 *   · TEXTY — popisky v pěti jazycích (vložený slovník, ne translations/*).
 *
 * BEZ KLIENTA NIC. Odkaz se tvoří jen pro klienta s id v CRM (contact_id).
 * Jen podle jména by se nedal znovu použít (backend ho nepozná) a doporučení
 * by nebyla svázaná s klientem, od kterého přišla.
 */
import QRCode from "qrcode";
import { whatsappOdkaz } from "@/lib/crm/zpravaDoporuceni";
import { odkazSms, jeAppleZarizeni } from "@/lib/telefonCislo";
import { HOTOVE, BEZI, zapomenOdkazyNaDoporuceni } from "@/lib/doporuceni/pametOdkazu";

export { zapomenOdkazyNaDoporuceni };

/* ── TEXTY (5 jazyků) ──────────────────────────────────────────────────────
 * Poradcovské popisky (tlačítka, regulační věta o odměně) i klientské věty
 * snímku prezentace. Chybějící jazyk = čeština (stejně jako lib/prekladyUI.js).
 * 15. 10. 2026 (SPEC-STAVBA §5.8, §5.11, R7): `prezTitul` = „Pomůžete mi?“ pro
 * plán i analýzu, `prezVeta` nová, `infoDoporucenym` + „a řádek smaž“;
 * `napoveda` (odměna jen se schválením) a `tlacitkoAnalyza` pryč — pravidlo
 * odměny je v Nastavení a odkaz se v Závěru připraví sám.
 * Kontrola 14. 10. 2026: pryč nápověda „Klient může kód naskenovat“ (majitel:
 * žádné vysvětlivky pro poradce) a chybová věta na plátně klienta; tlačítko
 * na plátně je „Poslat odkaz“, ne „Poslat klientovi“ (klientka by o sobě
 * četla ve třetí osobě). `infoDoporucenym` = jedna informační věta k ručně
 * zapsaným doporučením v analýze (zdroj údajů při prvním oslovení).
 * `predmet` (15. 10. 2026, SPEC §5.4) = totéž co predmetDoporuceni v lib/crm/
 * zpravaDoporuceni.js („Malá prosba, zabere minutu“) — shodu hlídá test.
 * ⚠️ Žádné ASCII uvozovky uvnitř textů (CLAUDE.md). */
export const TEXTY = {
  cs: {
    tlacitko: "Vygenerovat doporučení",
    tvorim: "Tvořím…",
    zpravaZkopirovana: "Zpráva zkopírována",
    zpravaZkopirovanaPopis: "Vlož ji do WhatsAppu — nebo použij tlačítko níž.",
    chyba: "Nepodařilo se vytvořit odkaz",
    zkusitZnovu: "Zkusit znovu",
    whatsapp: "Poslat přes WhatsApp",
    sms: "Poslat SMS",
    email: "Poslat e-mailem",
    kopirovat: "Kopírovat",
    zkopirovano: "Zkopírováno",
    kopirovaniSelhalo: "Zkopírovat se nepodařilo — označ text a zkopíruj ho ručně.",
    jazykZpravy: "Jazyk zprávy",
    textZpravy: "Text zprávy",
    qrPopis: "QR kód s odkazem na doporučení",
    predmet: "Malá prosba, zabere minutu",
    prezKicker: "Doporučení",
    prezTitul: "Pomůžete mi?",
    prezVeta: "Napadá Vás někdo, kdo teď něco řeší? Naskenujte kód a pošlete jméno a telefon. Zavolám jednou, nezávazně.",
    prezPripravuji: "Připravuji odkaz…",
    prezVetaBezKodu: "Stačí mi jméno a telefon. Ozvu se osobně a nezávazně.",
    prezPokracovat: "Pokračovat k doporučení",
    prezPoslat: "Poslat odkaz",
    prezPoslatTitulek: "Otevře aplikaci se zprávami",
    infoDoporucenym: "Při prvním hovoru řekni, od koho kontakt máš. Kdo nechce, toho dál neoslovuj a řádek smaž.",
  },
  sk: {
    tlacitko: "Vygenerovať odporúčanie",
    tvorim: "Vytváram…",
    zpravaZkopirovana: "Správa skopírovaná",
    zpravaZkopirovanaPopis: "Vlož ju do WhatsAppu — alebo použi tlačidlo nižšie.",
    chyba: "Odkaz sa nepodarilo vytvoriť",
    zkusitZnovu: "Skúsiť znova",
    whatsapp: "Poslať cez WhatsApp",
    sms: "Poslať SMS",
    email: "Poslať e-mailom",
    kopirovat: "Kopírovať",
    zkopirovano: "Skopírované",
    kopirovaniSelhalo: "Skopírovať sa nepodarilo — označ text a skopíruj ho ručne.",
    jazykZpravy: "Jazyk správy",
    textZpravy: "Text správy",
    qrPopis: "QR kód s odkazom na odporúčanie",
    predmet: "Malá prosba, zaberie minútu",
    prezKicker: "Odporúčanie",
    prezTitul: "Pomôžete mi?",
    prezVeta: "Napadá Vás niekto, kto teraz niečo rieši? Naskenujte kód a pošlite meno a telefón. Zavolám raz, nezáväzne.",
    prezPripravuji: "Pripravujem odkaz…",
    prezVetaBezKodu: "Stačí mi meno a telefón. Ozvem sa osobne a nezáväzne.",
    prezPokracovat: "Pokračovať k odporúčaniu",
    prezPoslat: "Poslať odkaz",
    prezPoslatTitulek: "Otvorí aplikáciu so správami",
    infoDoporucenym: "Pri prvom hovore povedz, od koho máš kontakt. Kto nechce, toho ďalej neoslovuj a riadok zmaž.",
  },
  en: {
    tlacitko: "Create a referral link",
    tvorim: "Creating…",
    zpravaZkopirovana: "Message copied",
    zpravaZkopirovanaPopis: "Paste it into WhatsApp — or use the buttons below.",
    chyba: "The link could not be created",
    zkusitZnovu: "Try again",
    whatsapp: "Send via WhatsApp",
    sms: "Send a text message",
    email: "Send by e-mail",
    kopirovat: "Copy",
    zkopirovano: "Copied",
    kopirovaniSelhalo: "Copying failed — select the text and copy it by hand.",
    jazykZpravy: "Message language",
    textZpravy: "Message text",
    qrPopis: "QR code with the referral link",
    predmet: "A small favour, it takes a minute",
    prezKicker: "Referrals",
    prezTitul: "Will you help me?",
    prezVeta: "Does anyone come to mind who is dealing with something right now? Scan the code and send me a name and a phone number. I will call once, with no obligation.",
    prezPripravuji: "Preparing the link…",
    prezVetaBezKodu: "A name and a phone number are all I need. I will get in touch personally, with no obligation.",
    prezPokracovat: "Continue to referrals",
    prezPoslat: "Send the link",
    prezPoslatTitulek: "Opens your messaging app",
    infoDoporucenym: "On the first call, say who gave you the contact. If someone says no, do not contact them again and delete the row.",
  },
  uk: {
    tlacitko: "Створити посилання для рекомендацій",
    tvorim: "Створюю…",
    zpravaZkopirovana: "Повідомлення скопійовано",
    zpravaZkopirovanaPopis: "Вставте його у WhatsApp — або скористайтеся кнопками нижче.",
    chyba: "Не вдалося створити посилання",
    zkusitZnovu: "Спробувати ще раз",
    whatsapp: "Надіслати через WhatsApp",
    sms: "Надіслати SMS",
    email: "Надіслати електронною поштою",
    kopirovat: "Копіювати",
    zkopirovano: "Скопійовано",
    kopirovaniSelhalo: "Не вдалося скопіювати — виділіть текст і скопіюйте вручну.",
    jazykZpravy: "Мова повідомлення",
    textZpravy: "Текст повідомлення",
    qrPopis: "QR-код із посиланням для рекомендацій",
    predmet: "Невелике прохання, це займе хвилину",
    prezKicker: "Рекомендації",
    prezTitul: "Допоможете мені?",
    prezVeta: "Чи спадає Вам на думку хтось, хто зараз щось вирішує? Відскануйте код і надішліть ім'я та номер телефону. Я зателефоную один раз, без зобов'язань.",
    prezPripravuji: "Готую посилання…",
    prezVetaBezKodu: "Мені достатньо імені та номера телефону. Я зв'яжуся особисто і без жодних зобов'язань.",
    prezPokracovat: "Перейти до рекомендацій",
    prezPoslat: "Надіслати посилання",
    prezPoslatTitulek: "Відкриє застосунок для повідомлень",
    infoDoporucenym: "Під час першого дзвінка скажіть, від кого маєте контакт. Хто відмовиться, тому більше не телефонуйте і видаліть рядок.",
  },
  vi: {
    tlacitko: "Tạo đường dẫn giới thiệu",
    tvorim: "Đang tạo…",
    zpravaZkopirovana: "Đã sao chép tin nhắn",
    zpravaZkopirovanaPopis: "Hãy dán vào WhatsApp — hoặc dùng các nút bên dưới.",
    chyba: "Không tạo được đường dẫn",
    zkusitZnovu: "Thử lại",
    whatsapp: "Gửi qua WhatsApp",
    sms: "Gửi SMS",
    email: "Gửi qua email",
    kopirovat: "Sao chép",
    zkopirovano: "Đã sao chép",
    kopirovaniSelhalo: "Không sao chép được — hãy bôi đen văn bản và sao chép thủ công.",
    jazykZpravy: "Ngôn ngữ tin nhắn",
    textZpravy: "Nội dung tin nhắn",
    qrPopis: "Mã QR có đường dẫn giới thiệu",
    predmet: "Một lời nhờ nhỏ, chỉ mất một phút",
    prezKicker: "Giới thiệu",
    prezTitul: "Anh/chị giúp tôi nhé?",
    prezVeta: "Anh/chị có biết ai đang có việc cần lo không? Hãy quét mã và gửi tên cùng số điện thoại. Tôi sẽ gọi một lần, không ràng buộc.",
    prezPripravuji: "Đang chuẩn bị đường dẫn…",
    prezVetaBezKodu: "Tôi chỉ cần tên và số điện thoại. Tôi sẽ tự liên hệ, hoàn toàn không ràng buộc.",
    prezPokracovat: "Tiếp tục đến phần giới thiệu",
    prezPoslat: "Gửi đường dẫn",
    prezPoslatTitulek: "Mở ứng dụng nhắn tin",
    infoDoporucenym: "Trong cuộc gọi đầu tiên, hãy nói bạn có số từ ai. Ai từ chối thì không liên hệ thêm và xóa dòng đó.",
  },
};

/** Text v jazyce; chybějící jazyk i klíč → čeština, nikdy holý klíč. */
export function textDoporuceni(klic, jazyk) {
  return (TEXTY[jazyk] && TEXTY[jazyk][klic]) || TEXTY.cs[klic] || "";
}

/* ── ZÍSKÁNÍ ODKAZU ────────────────────────────────────────────────────────
 * Hotový odkaz se drží 10 minut: dost na celou schůzku (prezentace, návrat do
 * analýzy, složka), a přitom se po vyplnění klientem brzy zeptáme backendu
 * znovu — ten pak vrátí nový token (starý už je „použit"). */
const PLATNOST_MS = 10 * 60 * 1000;
/* HOTOVE / BEZI jsou v lib/doporuceni/pametOdkazu.js — maže je i odhlášení. */

const idKlienta = (contactId) => String(contactId ?? "").trim();

/** Odkaz z paměti (platný), jinak "". Pro první vykreslení bez čekání. */
export function odkazZPameti(contactId) {
  const z = HOTOVE.get(idKlienta(contactId));
  return z && Date.now() - z.kdy < PLATNOST_MS ? z.odkaz : "";
}

/* Jazyky, které stránka /d/… umí (pages/ReferralPage.js). */
const JAZYKY_ODKAZU = ["cs", "sk", "en", "uk", "vi"];

/**
 * Odkaz s jazykem: `https://…/d/TOK` → `https://…/d/TOK?lang=vi`.
 * Stránka doporučení se pak otevře v jazyce zprávy / prezentace. Neznámý
 * jazyk = odkaz beze změny; existující `lang` se přepíše, nezdvojí.
 */
export function odkazSJazykem(odkaz, jazyk) {
  const url = String(odkaz ?? "").trim();
  if (!url) return "";
  if (!JAZYKY_ODKAZU.includes(jazyk)) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("lang", jazyk);
    return u.toString();
  } catch {
    return url;
  }
}

/**
 * Plná adresa formuláře doporučení pro klienta. Jedno volání backendu na
 * klienta; souběžná volání sdílí jeden požadavek.
 * @returns {Promise<string>} např. „https://app…/d/AbC123“
 * @throws  bez contact_id, při chybě API nebo bez cesty v odpovědi
 */
export function ziskejOdkazNaDoporuceni({ contactId, jmeno } = {}) {
  const id = idKlienta(contactId);
  if (!id) return Promise.reject(new Error("Chybí klient (contact_id)"));
  const hotovy = odkazZPameti(id);
  if (hotovy) return Promise.resolve(hotovy);
  if (BEZI.has(id)) return BEZI.get(id);

  const jmenoKlienta = String(jmeno ?? "").trim();
  /* `lib/api` se načítá až při prvním volání. Snímek Závěr (a s ním tenhle
   * modul) importují i testy plánu, které API vůbec nepotřebují — statický
   * import by do nich zatáhl axios. V aplikaci je modul už načtený, takže
   * dynamický import nic nestahuje. */
  const pozadavek = import("@/lib/api")
    .then(({ default: api }) => api.post("/api/referral/generate", {
      contact_id: id,
      ...(jmenoKlienta ? { client_name: jmenoKlienta } : null),
      target_count: 15,
    }))
    .then(({ data } = {}) => {
      /* Adresu skládá backend (`url_path`); kdyby chyběla, postaví se z tokenu.
       * Jiný tvar odpovědi = chyba, ne odkaz „/undefined“ v QR kódu. */
      const cesta = typeof data?.url_path === "string" && data.url_path.startsWith("/d/")
        ? data.url_path
        : (typeof data?.token === "string" && data.token ? `/d/${encodeURIComponent(data.token)}` : "");
      if (!cesta) throw new Error("Odpověď bez odkazu");
      const odkaz = `${window.location.origin}${cesta}`;
      HOTOVE.set(id, { odkaz, kdy: Date.now() });
      return odkaz;
    })
    .finally(() => { BEZI.delete(id); });
  BEZI.set(id, pozadavek);
  return pozadavek;
}

/* ── ODKAZY KE SDÍLENÍ ─────────────────────────────────────────────────────
 * Zpráva se NEODESÍLÁ — otevře se aplikace s předvyplněným textem a poradce
 * v ní klikne Odeslat. Všechno, co jde do adresy, jde přes encodeURIComponent. */

/* Rozumný e-mail: jedno @, tečka v doméně, žádné znaky, které by v mailto:
 * rozbily adresu nebo podstrčily další parametry (?, &, #, mezera, čárka). */
const EMAIL = /^[^\s@?&#,;:<>()[\]\\"]+@[^\s@?&#,;:<>()[\]\\"]+\.[^\s@?&#,;:<>()[\]\\"]{2,}$/;

export function platnyEmail(email) {
  return EMAIL.test(String(email ?? "").trim());
}

/** mailto: s předmětem a tělem; neplatný e-mail → "". */
export function mailtoOdkaz(email, predmet, text) {
  const adresa = String(email ?? "").trim();
  if (!platnyEmail(adresa)) return "";
  const zavinac = adresa.lastIndexOf("@");
  const prijemce = `${encodeURIComponent(adresa.slice(0, zavinac))}@${encodeURIComponent(adresa.slice(zavinac + 1))}`;
  /* RFC 6068: zlom řádku v těle je CRLF. Samotné LF některé poštovní
   * programy slijí do jednoho řádku a odkaz se přilepí k větě. */
  const telo = String(text ?? "").replace(/\r?\n/g, "\r\n");
  const parametry = [];
  if (predmet) parametry.push(`subject=${encodeURIComponent(predmet)}`);
  if (telo) parametry.push(`body=${encodeURIComponent(telo)}`);
  return `mailto:${prijemce}${parametry.length ? `?${parametry.join("&")}` : ""}`;
}

/** Apple zařízení oddělují tělo SMS `&`, ostatní `?`. JEDNA detekce pro celou
 *  appku (lib/telefonCislo.js → jeAppleZarizeni) — tatáž jako řada „Co má
 *  dodat klient“ v analýze (kontrola 14. 10. 2026). */
export function jeApple() {
  return jeAppleZarizeni();
}

/**
 * Odkazy pro tlačítka „Poslat klientovi". Prázdný řetězec = tlačítko se
 * nevykreslí (bez telefonu žádná SMS, bez e-mailu žádný e-mail).
 */
export function odkazyKSdileni({ zprava, zpravaSms, telefon, email, predmet, zeme, apple } = {}) {
  const text = String(zprava ?? "");
  if (!text.trim()) return { whatsapp: "", sms: "", email: "" };
  /* SMS má vlastní krátký text (SPEC §5.2, smsDoporuceni); bez něj celá zpráva. */
  const sms = String(zpravaSms ?? "").trim() || text;
  return {
    whatsapp: whatsappOdkaz(telefon, text, zeme),
    sms: odkazSms(telefon, sms, zeme, { ios: apple ?? jeApple() }),
    email: mailtoOdkaz(email, predmet, text),
  };
}

/** Text do schránky. Vrací true/false — schránka v nezabezpečeném okně chybí. */
export async function kopirujText(text) {
  try {
    if (!navigator?.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(String(text ?? ""));
    return true;
  } catch {
    return false;
  }
}

/* ── QR ────────────────────────────────────────────────────────────────────
 * Úroveň opravy M (15 %): odkaz /d/<token> se vejde do verze 3–4, moduly jsou
 * velké a kód se dá naskenovat i z projektoru přes stůl. */
export function qrMatice(text) {
  const t = String(text ?? "").trim();
  if (!t) return null;
  try {
    const q = QRCode.create(t, { errorCorrectionLevel: "M" });
    return { velikost: q.modules.size, data: q.modules.data };
  } catch {
    return null;
  }
}

/**
 * SVG cesta tmavých modulů. Souvislé úseky v řádku se kreslí jedním
 * obdélníkem (méně uzlů, žádné vlasové spáry mezi moduly při zmenšení).
 * `okraj` = tichá zóna kolem kódu v modulech — 4 podle ISO 18004 (kontrola
 * 14. 10. 2026: se 2 moduly a tmavou kartou kolem se sken z projektoru
 * nedal zaručit).
 */
export const QR_OKRAJ = 4;
export function qrCesta(matice, okraj = QR_OKRAJ) {
  if (!matice || !matice.velikost) return "";
  const { velikost, data } = matice;
  const casti = [];
  for (let y = 0; y < velikost; y += 1) {
    let x = 0;
    while (x < velikost) {
      if (!data[y * velikost + x]) { x += 1; continue; }
      const start = x;
      while (x < velikost && data[y * velikost + x]) x += 1;
      casti.push(`M${start + okraj} ${y + okraj}h${x - start}v1h-${x - start}z`);
    }
  }
  return casti.join("");
}
